// extracted by mini-css-extract-plugin
export default {"top_cat_main":"top-category_top_cat_main__uVcfO","title":"top-category_title__9VwI3"};